import { Fragment } from 'react'
import { Container } from 'src/components/common/Container'
import styled, { keyframes } from 'styled-components'
import intro_image from 'src/assets/images/intro/intro_barcode_contents.png'
import intro_button_object from 'src/assets/images/intro/intro_chatbubble_contents.png'
import { Typography } from 'src/components/common/Typography'
import { Noto_DisPlay2_b32, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import usePageNav from 'src/hooks/usePageNav.hook'
import { mediaMaxWidth } from 'src/styles/mixin'

const IntroPageView = () => {
  const { joinPageNav } = usePageNav()

  return (
    <S.IntroPageContainer $option="flex_column">
      <S.IntroTextContainer $option="flex_column" $row_gap="4px" $width="fit-content">
        <Typography $fontStyle={Noto_DisPlay2_b32} $color="var(--white)">
          <S.TitleReveal>
            {'GS25 쿠폰 발급 완료'.split('').map((char, i) => (
              <Fragment key={i}>
                {i === 7 && <S.IntroTextBrTag />}
                <S.TitleChar $delay={i * 0.06}>{char === ' ' ? '\u00A0' : char}</S.TitleChar>
              </Fragment>
            ))}
          </S.TitleReveal>
        </Typography>
        <S.SubtitleReveal>
          <Typography $fontStyle={Noto_subheading_b18} $color="var(--black-6)">
            매월 전원 <i style={{ textDecoration: 'underline' }}>무료 제공</i>
          </Typography>
        </S.SubtitleReveal>
      </S.IntroTextContainer>
      <S.IntroImgContainer $option="flex_column">
        <S.IntroImage src={intro_image} alt="intro img" />
      </S.IntroImgContainer>
      <S.IntroBottomContainer>
        <S.IntroGoMainNavButton onClick={joinPageNav}>
          <S.IntroButtonObjectContainer>
            <S.IntroButtonObject src={intro_button_object} alt="intro img" />
          </S.IntroButtonObjectContainer>
          <Typography $fontStyle={Noto_subheading_b18} $color="var(--black-90)">
            확인
          </Typography>
        </S.IntroGoMainNavButton>
      </S.IntroBottomContainer>
    </S.IntroPageContainer>
  )
}
export default IntroPageView

//말풍선 이미지 motion
const float = keyframes`
  0%, 100% {
     bottom: 65px;
  }
  50% {
     bottom: 60px;
  }
`
//타이틀 motion
const titleReveal = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const subtitleFadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const S = {
  IntroPageContainer: styled(Container)`
    background: #0084ff;
    height: calc(var(--vh, 1vh) * 100);
    align-items: center;
    padding: 20px;
    flex: 1;
    justify-content: center;
    align-items: center;
  `,
  IntroImgContainer: styled(Container)`
    max-width: 400px;
    margin-top: 30px;
    box-sizing: border-box;
    @media (max-width: 540px) {
      max-width: 300px;
    }
  `,
  IntroTextContainer: styled(Container)`
    margin: 0 auto;
    text-align: center;
    ${mediaMaxWidth('540')} {
      max-width: 260px;
    }
  `,
  TitleReveal: styled.span`
    display: inline-block;
    white-space: pre;
  `,
  TitleChar: styled.span<{ $delay: number }>`
    display: inline-block;
    animation: ${titleReveal} 0.4s ease-out ${({ $delay }) => $delay}s both;
  `,
  SubtitleReveal: styled.div`
    animation: ${subtitleFadeUp} 0.6s ease-out 0.35s both;
  `,
  IntroTextBrTag: styled.br`
    display: none;
    ${mediaMaxWidth('540')} {
      display: block;
    }
  `,
  IntroBottomContainer: styled(Container)`
    margin: 0 auto 30px auto;
    max-width: 460px;
    margin-top: 60px;
    ${mediaMaxWidth('540')} {
      margin-top: 30px;
      padding: 0;
    }
  `,
  IntroImage: styled.img`
    width: 100%;
  `,
  IntroButtonObjectContainer: styled(Container)`
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 65px;
    animation: ${float} 1.5s ease-in-out infinite;
  `,
  IntroButtonObject: styled.img`
    max-width: 320px;
    ${mediaMaxWidth('540')} {
      max-width: 220px;
    }
  `,
  IntroGoMainNavButton: styled.button`
    position: relative;
    display: flex;
    justify-content: center;
    padding: 12px 16px;
    border-radius: 14px;
    background: var(--white);
    width: 100%;
    margin: 0 auto;
    height: 56px;
    gap: 5px;
    ${mediaMaxWidth('540')} {
      max-width: 320px;
    }
  `,
}
